import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import IconButton from 'fe-design-base/molecules/IconButton';

import { toI18n } from 'util/i18n';

type CollapsibleCardProps = {
  title: string;
  count: number;
  show: boolean;
  handleToggle: () => void;
  children: React.ReactNode;
};

const CollapsibleCard = ({
  title,
  count,
  show,
  handleToggle,
  children,
}: CollapsibleCardProps) => (
  <Box bw={1} bcolor="mono400" bradiusm p={16} bgcolor="mono0">
    <Box row justifyContentSpaceBetween alignItemsCenter>
      <Text
        variant="heading4"
        i18n={`requests_feed.trade.details.${title}`}
        i18nProps={{ count }}
      />
      <IconButton
        icon={show ? 'ChevronUp' : 'ChevronDown'}
        label={toI18n(`requests_feed.trade.details.toggle_${title}`)}
        onClick={handleToggle}
      />
    </Box>
    {show && <>{children}</>}
  </Box>
);

export default CollapsibleCard;
